export enum ImoFoundResultEnum {
  NOT_FOUND_FIX = 1,
  NOT_FOUND_CONTINUE = 2,
  FOUND_FIX_IMO = 3,
  FOUND_MANUAL_SET = 4,
  FOUND_CONTINUE = 5,
  INITIALIZED = 6,
}
